import React from "react";
import {
    Grid,
    Box,
    Typography,
    Snackbar,
    Alert,
} from "@mui/material";
import { CustomBreadCrumbs } from "../../components/";
import { AccountTabPanel } from "../../components/AccountTabPanel";
import { useAccounts } from "./hook";
import { FormFileDialog } from "../../components/FormFileDialog";
import { AddUserDialog } from "../../components/AddUserDialog";
import { AlertDialog } from "../../components/AlertDialog";

export const Accounts = (): JSX.Element => {
    const {
        fileMessage,
        isError,
        isAddUserDialogOpen,
        isUploadFileDialogOpen,
        isWarningDialogOpen,
        snackbarSeverity,
        onCloseWarningDialog,
        onOpenWarningDialog,
        onCloseUploadFileDialog,
        onHandleSelectionFile,
        openSelectionFile,
        selectedFile,
        textMatrix,
        onOpenFileUploadDialog,
        onOpenAddUserUploadDialog,
        onSaveFile,
        isSnackbarOpen,
        onCloseSnackbar,
        onOpenSnackbar,
        onCloseAddUser,
        snackbarMessage
    } = useAccounts();

    return (
        <>
            <Grid sx={{ mt: 2.8, mb: 2.5 }}>
                <CustomBreadCrumbs path="Home/Accounts" />
            </Grid>
            <Grid xs={12} sm={5} md={5} lg={8} sx={{ mb: 2.5 }}>
                <Typography textAlign={{ xs: "center", sm: "start" }} variant="h4" sx={{ mb: 1.25, color: "#1BA0E9", fontWeight: 600, fontSize: 25 }} >
                    Accounts
                </Typography>
            </Grid>
            <Box mt={4}>
                <AccountTabPanel 
                    onClickAddUser={onOpenAddUserUploadDialog}
                    onClickTerritory={onOpenFileUploadDialog}
                />
            </Box>
            <FormFileDialog
                file={selectedFile}
                textMatrix={textMatrix}
                fileMessage={fileMessage}
                isOpen={isUploadFileDialogOpen}
                isError={isError}
                onClose={onCloseUploadFileDialog}
                onHandleSelectionFile={onHandleSelectionFile}
                onOpenSelectionFile={openSelectionFile}
                onSave={onOpenWarningDialog}
            />
            <AlertDialog 
                open={isWarningDialogOpen}
                title="Warning" 
                description="this will wipe the existing territory and replace it with what you have uploaded. If that is correct, please click Save to continue"
                onContinue={onSaveFile}
                onCancel={onCloseWarningDialog}
                invertButtons
                onSubmitButtonProps={{
                    title: "Save"
                }}
                onCancelButtonProps={{
                    title: "Cancel"
                }}
                type="warning"  
            /> 
            <AddUserDialog 
                isOpen={isAddUserDialogOpen} 
                onClose={onCloseAddUser}
            />
            <Snackbar key={9} open={isSnackbarOpen} anchorOrigin={{ vertical: "bottom", horizontal: "right" }} onClose={onCloseSnackbar} autoHideDuration={2000}>
                <Alert severity={snackbarSeverity as any} >
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </>
    )
}